define([
    "dojo/on",
    "dijit/focus",
    "mw-form/ContextMenu",
    "mw-form/Menu",
    "mw-form/MenuItem",
    "mw-form/CheckBoxMenuItem",
    "mw-form/RadioButtonMenuItem",
    "mw-form/MenuSeparator",
    "mw-form/PopupMenuItem",
    "dijit/popup",
    "MW/layout/SelectionBlocker"
], function (on, focus, ContextMenu, Menu, MenuItem, CheckBoxMenuItem, RadioButtonMenuItem, MenuSeparator, PopupMenuItem, popup, SelectionBlocker) {

    return {

        display: function (parentNode, actions) {
            if (!actions) {
                return;
            }
            if (parentNode._actionsMenu) {
                parentNode._actionsMenu.close();
                return;
            }
            SelectionBlocker.blockSelection(parentNode);
            parentNode._actionsMenu = new ContextMenu({
                targetNodes: [parentNode],
                id: "ActionsMenu"
            });
            this._addMenuItems(parentNode._actionsMenu, actions);
            parentNode._actionsMenu.open({target: parentNode});
            parentNode._actionsMenu.on("close", function() {
                // Destroying immediately causes error in menu close code
                setTimeout(function() {
                    parentNode._actionsMenu.destroyRecursive();
                    delete parentNode._actionsMenu;
                    var actionsButtonWrapper = parentNode.parentElement;
                    if (actionsButtonWrapper) {
                        actionsButtonWrapper.removeAttribute("aria-expanded");
                    }
                }, 0);
                SelectionBlocker.unblockSelection();
            });
        },

        _addMenuItems: function(menu, actions) {
            var i, action, item, clickHandler, subMenu;
            for (i = 0; i < actions.length; i++) {
                action = actions[i];
                if (!action) {
                    // Add a separator
                    menu.addChild(new MenuSeparator());
                } else if (action instanceof Array) {
                    // Add a sub-menu
                    subMenu = new Menu();
                    this._addMenuItems(subMenu, action.slice(1));
                    menu.addChild(new PopupMenuItem({
                        text: action[0],
                        menu: subMenu
                    }));
                } else {
                    clickHandler = function (actionToExecute) {
                        return function (e) {
                            if (!(actionToExecute.enabled || (actionToExecute.getEnabled && actionToExecute.getEnabled()))) {
                                return;
                            }
                            var getterSetterAvailable = (actionToExecute.setSelected && actionToExecute.getSelected);
                            var isSelected = getterSetterAvailable ? actionToExecute.getSelected() : actionToExecute.selected;
                            var toggleSelectionAndExecuteCallback = function (actionToExecute, getterSetterAvailable) {
                                getterSetterAvailable ?
                                actionToExecute.setSelected(!actionToExecute.getSelected()) :
                                actionToExecute.selected = !actionToExecute.selected;
                                actionToExecute.callback(e);
                            };
                            // Three cases, one for each type of actions:
                            // 1. Checkbox: 
                            //      Toggle selection and execute associated callback
                            // 2. Radiobutton:
                            //      Toggle selection and execute associated callback only if it was not already selected
                            // 3. Regular MenuItem:
                            //      execute associated callback
                            if (actionToExecute.itemType === "check") {
                                toggleSelectionAndExecuteCallback(actionToExecute, getterSetterAvailable);
                            } else if (actionToExecute.itemType === "radio") {
                                if (!isSelected) toggleSelectionAndExecuteCallback(actionToExecute, getterSetterAvailable);
                            } else {
                                actionToExecute.callback(e);
                            }
                            popup.close();
                        }
                    }(action);
                    // Add the appropriate menu item type
                    if (action.itemType === "check") {
                        item = new CheckBoxMenuItem({
                            text: action.text,
                            disabled: !(action.getEnabled ? action.getEnabled() : action.enabled),
                            checked: action.getSelected ? action.getSelected() : action.selected
                        });
                    } else if (action.itemType === "radio") {
                        item = new RadioButtonMenuItem({
                            text: action.text,
                            disabled: !(action.getEnabled ? action.getEnabled() : action.enabled),
                            checked: action.getSelected ? action.getSelected() : action.selected,
                        });
                    } else {
                        item = new MenuItem({
                            text: action.text,
                            disabled: !(action.getEnabled ? action.getEnabled() : action.enabled)
                        });
                    }
                    on(item, "click", clickHandler);
                    menu.addChild(item);
                }
            }
        }
    };
});
